import emptySplitApi from "../utils/rtk";
import { END_POINTS } from "../helpers";

export const paymentApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentHistory: builder.mutation({
      query: (body) => ({
        url: `${END_POINTS.paymentHistory}`,
        method: "POST",
        body,
      }),
    }),
    getPayments: builder.query({
      query: () => ({
        url: `${END_POINTS.paymentDashboard}`,
        method: "GET",
      }),
    }),

    withdrawPayment: builder.mutation({
      query: (body) => ({
        url: `${END_POINTS.paymentRequest}`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetPaymentHistoryMutation,
  useLazyGetPaymentsQuery,
  useWithdrawPaymentMutation,
} = paymentApi;
